module.exports = __webpack_public_path__ + "static/media/mastercard-icon.ad0ff83e.svg";